import { useEffect, useRef } from "react"
import { Navigate, Outlet } from "react-router-dom"
import { useAuthStore } from "@/stores/auth-store"

export function PublicRoute() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const isLoading = useAuthStore((state) => state.isLoading)
  const fetchUser = useAuthStore((state) => state.fetchUser)
  const hasFetched = useRef(false)

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true
      fetchUser()
    }
  }, [fetchUser])

  // Still checking — render nothing (very brief)
  if (isLoading) {
    return null
  }

  // Authenticated — redirect to dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return <Outlet />
}
